// extracted by mini-css-extract-plugin
export default {"box":"Integrations_box__G92Zv","heading":"Integrations_heading__1E0Si","text":"Integrations_text__hE3oP","image":"Integrations_image__L9Srx"};